module.exports = __webpack_public_path__ + "media/images/athletes/3594-5361470cc5559b1e3296df45e6624794.png";